import CustomTable from "@/components/CustomTable";
import { useState } from "react";
import { columns } from "./common/columns";
import { useQuery } from "@tanstack/react-query";
import {
  getAllBalances,
  getAvailableBalances,
  getTotalTransactions,
} from "@/services/Home.service";
import FundAccount from "./common/FundAccount";
import Withdraw from "./common/Withdraw";
import CustomTabs from "@/components/CustomTabs";
import { Skeleton } from "@/components/ui/skeleton";

const Balances = () => {
  const transaction = useQuery({
    queryKey: ["transactionSum"],
    queryFn: async () => await getTotalTransactions(),
    refetchOnMount: "always",
  });
  const { data, isLoading } = useQuery({
    queryKey: ["allBalances"],
    queryFn: async () => await getAllBalances(),
    refetchOnMount: "always",
  });
  const available = useQuery({
    queryKey: ["getAvailableBalances"],
    queryFn: async () => await getAvailableBalances(),
    refetchOnMount: "always",
  });

  return (
    <div className="grid p-6 py-12 gap-[44px]">
      <div className="flex items-center gap-4">
        <div className="flex-col gap-2">
          <p className="text-2xl font-medium text-primary-3">Balances</p>
          <p className="text-base text-gray-80">
            Track and manage your liquidity
          </p>
        </div>

        <div className="ml-auto flex items-center gap-6">
          <FundAccount />
          <Withdraw balance={data?.data?.data} />
        </div>
      </div>
      <div className="grid grid-cols-3  border-[#EAE6EA] border-[1px] rounded-[12px] p-6">
        <div className="grid gap-4">
          <h3 className="text-primary-4 text-sm font-medium">
            Available Balance
          </h3>
          {available?.data?.data?.data === undefined ? (
            <Skeleton className="w-40 h-6" />
          ) : (
            <p className="text-primary-1 font-medium text-2xl">
              {available?.data?.data?.data?.availablelMainBalance?.toLocaleString(
                "en-US",
                {
                  style: "currency",
                  currency: "USD",
                }
              )}
            </p>
          )}
        </div>
        <div className="grid gap-4">
          <h3 className="text-primary-4 text-sm font-medium">
            Pending Balance
          </h3>
          {available?.data?.data?.data === undefined ? (
            <Skeleton className="w-40 h-6" />
          ) : (
            <p className="text-primary-1 font-medium text-2xl">
              {available?.data?.data?.data?.availablelPendingBalance?.toLocaleString(
                "en-US",
                {
                  style: "currency",
                  currency: "USD",
                }
              )}
            </p>
          )}
        </div>
        <div className="grid gap-4">
          <h3 className="text-primary-4 text-sm font-medium">
            Total Transacted Volume
          </h3>

          {transaction?.data?.data?.data === undefined ? (
            <Skeleton className="w-40 h-6" />
          ) : (
            <p className="text-primary-1 font-medium text-2xl">
              {transaction?.data?.data?.data?.result?.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              })}
            </p>
          )}
        </div>
      </div>

      <div className="container mx-auto">
        <CustomTabs
          tabs={["Business Balances", "Customer Balances"]}
          tabData={{
            "Business Balances": (
              <div className="border rounded-md">
                <CustomTable
                  columns={columns}
                  data={data?.data?.data ?? []}
                  // shoePagination={false}
                  isLoading={isLoading}
                />
              </div>
            ),
            "Customer Balances": (
              <div className="flex justify-center items-center">
                <h4 className="text-4xl text-primary-2">Not Available</h4>
              </div>
            ),
          }}
        />
      </div>
    </div>
  );
};
export default Balances;
